import "./Button.css";

function Button({
  children,
  onClick,
  type = "button",
  variant = "primary",
  icon,
  iconPosition = "left",
  fullWidth = false,   // 👈 new prop
  disabled = false,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${variant === "primary" ? "btn-primary" : "btn-secondary"} ${fullWidth ? "btn-full" : ""}`}
    >
      {icon && iconPosition === "left" && <img src={icon} alt="" className="btn-icon" />}
      {children}
      {icon && iconPosition === "right" && <img src={icon} alt="" className="btn-icon" />}
    </button>
  );
}

export default Button;
